<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import SidenavList from "./SidenavList.vue";
import logoWhiteScala from "@/assets/img/scala-footer.png";
import logoBlackScala from "@/assets/img/Scala-New.png";

const store = useStore();
const isRTL = computed(() => store.state.isRTL);
const layout = computed(() => store.state.layout);
const sidebarType = computed(() => store.state.sidebarType);
const darkMode = computed(() => store.state.darkMode);
</script>
<template>
  <div
    v-show="layout === 'default'"
    class="min-height-300 position-absolute w-100"
    :class="`${darkMode ? 'bg-transparent' : 'bg-dark'}`"
  />

  <aside
    class="my-3 overflow-auto border-0 sidenav navbar navbar-vertical navbar-expand-xs border-radius-xl sidenav-custome"
    :class="`${isRTL ? 'me-3 rotate-caret fixed-end' : 'fixed-start ms-3'}    
      ${
        layout === 'landing' ? 'bg-transparent shadow-none' : ' '
      } ${sidebarType}`"
    id="sidenav-main"
    data-color="dark"
  >
    <div class="sidenav-header">
      <i
        class="top-0 p-3 cursor-pointer fas fa-times text-secondary opacity-5 position-absolute end-0 d-none d-xl-none"
        aria-hidden="true"
        id="iconSidenav"
      ></i>

      <div class="d-flex justify-content-center align-items-center" style="height: 100%;">
        <router-link class="p-4" to="/">
          <img
            :src="darkMode || sidebarType === 'bg-default' ? logoWhiteScala : logoBlackScala"
            class="img-fluid"
            alt="main_logo"
          />
        </router-link>
      </div>
    </div>

    <hr class="mt-0 horizontal dark" />

    <sidenav-list />
  </aside>
</template>
<style>
@media (min-width: 768px) and (max-width: 1200px) {
  .sidenav-custome {
    z-index: 0;
  }
}

</style>